import React from 'react';
import './styles.scss';
import {Column, Row} from '../layout';
import * as fonts from '../../util/fonts';
import {strings} from '../../util/strings';
import {connect} from 'react-redux';
import ContainerDocumentDownload from '../container-document-download';

export interface PreAuthorization {
  dos: string;
  decisionstate: string;
  decisionstateId: string;
  providername: string;
  clinicname: string;
  surviceNumber: string;
  convencao: string;
  amountdeduct?: any;
  amountdisallow?: any;
  amountpaid?: any;
  code?: any;
  indicator?: boolean;
}

interface PreAuthorizationDetailProps {
  process?: any;
  occorenceDate: any;
  documents: any[];
  refundLabels: typeof strings.pt.refund;
  labelsPreAuthorizations: typeof strings.pt.preAuthorizations;
  estadoId?: string;
  provider?: string;
  procedure?: string;
  patientName?: string;
}

function PreAuthorizationsDetail({
  labelsPreAuthorizations,
  process,
  occorenceDate,
  estadoId,
  refundLabels,
  provider,
  procedure,
  patientName,
  documents,
}: PreAuthorizationDetailProps) {
  return (
    <Column className="reimbursement-success-content-container">
      <Column className="pre-auth-success-outer">
        <Column className="reimbursement-success-box-column">
          <Row className="reimbursement-success-row">
            <Column className="reimbursement-success-row-column">
              <Row className="reimbursement-success-row-template">
                <Column className="reimbursement-success-row-left">
                  <Row className="reimbursement-success-row-left-align">
                    <Column style={{...fonts.ML, fontSize: '17px !important'}}>
                      {refundLabels?.refundDetail_process}
                    </Column>
                    <Column
                      className="reimbursement-success-result"
                      style={{...fonts.ML, fontSize: '17px !important'}}>
                      {process}
                    </Column>
                  </Row>
                  <Row className="reimbursement-success-row-left-align">
                    <Column style={{...fonts.ML, fontSize: '17px !important'}}>
                      {refundLabels?.refundDetail_pacient}
                    </Column>
                    <Column
                      className="reimbursement-success-result"
                      style={{...fonts.ML, fontSize: '17px !important'}}>
                      {patientName ?? '-'}
                    </Column>
                  </Row>
                  <Row className="reimbursement-success-row-left-align">
                    <Column style={{...fonts.ML, fontSize: '17px !important'}}>
                      {
                        labelsPreAuthorizations?.refund_preAuthorization_filter_processTypeLabel
                      }
                    </Column>
                    {procedure ? (
                      <Column
                        className="reimbursement-success-result-procedure"
                        style={{...fonts.ML, fontSize: '17px !important'}}>
                        {procedure}
                      </Column>
                    ) : (
                      <Column
                        className="reimbursement-success-result"
                        style={{...fonts.ML, fontSize: '17px !important'}}>
                        {'-'}
                      </Column>
                    )}
                  </Row>
                </Column>
                <Column className="reimbursement-success-row-right">
                  <Row className="reimbursement-success-row-left-align">
                    <Column style={{...fonts.ML, fontSize: '17px !important'}}>
                      {refundLabels?.refundDetail_date}
                    </Column>
                    <Column
                      className="reimbursement-success-result"
                      style={{...fonts.ML, fontSize: '17px !important'}}>
                      {occorenceDate}
                    </Column>
                  </Row>
                  {estadoId !== '1' && estadoId !== '' && (
                    <Row className="reimbursement-success-row-left-align">
                      <Column
                        style={{...fonts.ML, fontSize: '17px !important'}}>
                        {refundLabels?.refundDetail_provider}
                      </Column>
                      <Column
                        className="reimbursement-success-result"
                        style={{...fonts.ML, fontSize: '17px !important'}}>
                        {provider}
                      </Column>
                    </Row>
                  )}
                </Column>
              </Row>
            </Column>
          </Row>
        </Column>
        {labelsPreAuthorizations.refund_preAuthorization_detail_emitDoc_visible ===
          '1' && (
          <Row>
            {documents.length > 0 && (
              <ContainerDocumentDownload
                submittedFiles={documents}
                title={
                  labelsPreAuthorizations.refund_preAuthorization_detail_emitDocLabel
                }
              />
            )}
          </Row>
        )}
      </Column>
    </Column>
  );
}

const mapStateToProps = ({strings}: any) => {
  return {
    refundLabels: strings.value.pt.refund,
    labelsPreAuthorizations: strings.value.pt.preAuthorizations,
  };
};

export default connect(mapStateToProps)(PreAuthorizationsDetail);
